import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import NetworkBarGroupLink from '../NetworkBarGroupLink';
import Button from '../../../Button';
import GroupLinkLoader from '../GroupLinkLoader';
import NetworkBarItemGroup from '../NetworkBarItemGroup';
import { useNormalizedUserStream } from '../../../utils/hooks/useStream';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './FoldableGroupList.scss';
var FoldableGroupList = function (_a) {
    var streamId = _a.streamId, tabIndex = _a.tabIndex, isCollapsed = _a.isCollapsed, selectedItem = _a.selectedItem, selectedItemClassName = _a.selectedItemClassName, title = _a.title, icon = _a.icon, isFolded = _a.isFolded, toggleAriaLabel = _a.toggleAriaLabel, onFoldToggle = _a.onFoldToggle, className = _a.className, sectionType = _a.sectionType;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useNormalizedUserStream(streamId), groups = _b.items, hasMore = _b.hasMore, isFetching = _b.isFetching, fetchNext = _b.fetchNext, errorMessage = _b.errorMessage;
    if (!isFetching && !groups.length && (!hasMore || errorMessage)) {
        return null;
    }
    var hasNewContent = groups.some(function (group) { var _a; return (_a = group.networkbar) === null || _a === void 0 ? void 0 : _a.hasNewContent; });
    return (React.createElement(NetworkBarItemGroup, { title: title, icon: icon, isCollapsed: isCollapsed, className: className, hasNewContent: hasNewContent, withFolding: true, isFolded: isFolded, toggleAriaLabel: toggleAriaLabel, onFoldToggle: function () { return onFoldToggle(sectionType, !isFolded); }, biData: {
            evid: BiEventType.NETWORK_BAR_SECTION_EXPAND_COLLAPSE,
            is_expanding: isFolded ? 1 : 0,
            indicator: hasNewContent ? 1 : 0,
        } },
        React.createElement("ul", null,
            groups.map(function (group, index) { return (React.createElement("li", { key: group.userId },
                React.createElement(NetworkBarGroupLink, { group: group, tabIndex: tabIndex, rank: index, isCollapsed: !isMobile && isCollapsed, isSelected: selectedItem === group.userId, className: classnames(selectedItem === group.userId && selectedItemClassName) }))); }),
            isFetching && (React.createElement(React.Fragment, null,
                React.createElement("li", null,
                    React.createElement(GroupLinkLoader, { isCollapsed: isCollapsed })),
                React.createElement("li", null,
                    React.createElement(GroupLinkLoader, { isCollapsed: isCollapsed })),
                React.createElement("li", null,
                    React.createElement(GroupLinkLoader, { isCollapsed: isCollapsed }))))),
        hasMore && !isFetching && !isCollapsed && (React.createElement(Button, { view: "b33", className: s['more-button'], onClick: fetchNext, tabIndex: tabIndex }, t('networkBar.groups.showMore')))));
};
FoldableGroupList.displayName = 'FoldableGroupList';
export default FoldableGroupList;
//# sourceMappingURL=FoldableGroupList.js.map